export const COLLABORATOR_ROLES = {
    ADMINISTRATOR: 2,
    EDITOR: 1,
    VIEWER: 0
}